import { useState, useRef, useEffect } from 'react'

export default function HeadingBlock({ settings, onInlineUpdate }) {
  const { padding, margin, backgroundColor, borderWidth, borderColor, borderRadius } = settings
  const [isEditing, setIsEditing] = useState(false)
  const editorRef = useRef(null)

  const containerStyle = {
    padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`,
    margin: `${margin.top} ${margin.right} ${margin.bottom} ${margin.left}`,
    backgroundColor: backgroundColor || 'transparent',
    border: (borderWidth && borderWidth !== '0px') ? `${borderWidth} solid ${borderColor || '#cccccc'}` : 'none',
    borderRadius: borderRadius || '0px',
    position: 'relative',
    ...(settings.backgroundImage ? {
      backgroundImage: `url(${settings.backgroundImage})`,
      backgroundSize: settings.backgroundSize || 'cover',
      backgroundPosition: settings.backgroundPosition || 'center center',
      backgroundRepeat: settings.backgroundRepeat || 'no-repeat'
    } : {})
  }

  const headingStyle = {
    margin: 0,
    fontSize: settings.fontSize,
    fontFamily: settings.fontFamily,
    fontWeight: settings.fontWeight,
    color: settings.color,
    textAlign: settings.textAlign,
    lineHeight: settings.lineHeight,
    outline: 'none',
    cursor: isEditing ? 'text' : 'inherit',
    borderBottom: isEditing ? '2px solid var(--color-primary)' : 'none',
    transition: 'border-bottom 0.15s'
  }

  useEffect(() => {
    if (isEditing && editorRef.current) {
      editorRef.current.focus()
      const range = document.createRange()
      const sel = window.getSelection()
      range.selectNodeContents(editorRef.current)
      range.collapse(false)
      sel.removeAllRanges()
      sel.addRange(range)
    }
  }, [isEditing])

  const handleDoubleClick = (e) => {
    if (onInlineUpdate) {
      e.stopPropagation()
      setIsEditing(true)
    }
  }

  const handleBlur = () => {
    if (isEditing && editorRef.current && onInlineUpdate) {
      onInlineUpdate({ content: editorRef.current.textContent })
      setIsEditing(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      editorRef.current?.blur()
    }
    if (e.key === 'Escape') {
      setIsEditing(false)
      editorRef.current?.blur()
    }
  }

  if (isEditing) {
    return (
      <div style={containerStyle}>
        <h2
          ref={editorRef}
          contentEditable
          suppressContentEditableWarning
          style={headingStyle}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        >
          {settings.content}
        </h2>
      </div>
    )
  }

  return (
    <div style={containerStyle} onDoubleClick={handleDoubleClick}>
      <h2 style={headingStyle}>{settings.content}</h2>
    </div>
  )
}
